import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { DataBagService } from 'src/app/common/data-bag.service';
import { OrganizationService } from './organization.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { PageFunction } from '@/common/enums/PageFunction';

@Component({
	selector: 'app-organization',
	templateUrl: './organization.component.html',
	styleUrls: ['./organization.component.css'],
})
export class OrganizationComponent implements OnInit, OnDestroy {
	activeTabIndex = signal(0);

	readonly pageTitle = 'Organizacje';
	readonly pageFunction = PageFunction.EDIT;

	readonly tabs = [
		{
			label: 'Organizacja',
			icon: 'fa-solid fa-sitemap',
			component: 'primary',
		},
		{
			label: 'Konta Bankowe',
			icon: 'fa-solid fa-credit-card',
			component: 'bank',
		},
		{
			label: 'Osoby kontaktowe',
			icon: 'fa-solid fa-address-card',
			component: 'contacts',
		},
		// This module is currently unused and has been commented out. It may be useful in the future.
		// {
		// 	label: 'Pracownicy',
		// 	icon: 'fa-solid fa-user-secret',
		// 	component: 'workers',
		// },
		{
			label: 'Ubezpieczenia',
			icon: 'fas fa-balance-scale-right',
			component: 'insurer',
		},
	];

	editable = false;
	protected api = 'bag';
	protected apiType = 'bag';
	protected apiUrlAdd = '/organization/';
	protected apiUrl = '/organization/';
	protected parentComponent = 'organization';
	protected idType = 'char';

	constructor(
		private readonly bag: DataBagService,
		public service: OrganizationService,
		public loader: LoaderService,
	) {}

	ngOnInit(): void {
		this.loader.show();
		this.loadData();
	}

	ngOnDestroy(): void {
		this.service.resetData();
	}

	protected loadData(): void {
		this.bag.get('/organization/role/', (result, error) => {
			this.service.enterpriseData.organizationRoles = result.results;
		});

		this.bag.get('/organization/department/', (result, error) => {
			this.service.enterpriseData.organizationDepartments = result.results;
		});

		this.bag.get('/location/?limit=9999', (result, error) => {
			this.service.enterpriseData.locations = result.results;
		});

		this.bag.get('/sell_category/?limit=999', (result, error) => {
			this.service.enterpriseData.sellCategory = result.results;
		});

		this.bag.get('/account_kind/', (result, error) => {
			this.service.enterpriseData.accountKind = result.results;
		});
		this.bag.get('/address_kind/', (result, error) => {
			this.service.enterpriseData.addressKind = result.results;
		});

		this.bag.get('/currency/', (result, error) => {
			this.service.enterpriseData.currency = result.results;
		});

		this.bag.get('/organization/department_kind/', (result, error) => {
			this.service.enterpriseData.departmentKinds = result.results;
		});

		this.bag.get('/profile/all_users/', (result, error) => {
			this.service.enterpriseData.departmentUsers = result.results;
		});
	}
}
